const translation = {
  boycottLabel: {
    ar: "قاطعوا من يؤيد قتل الفلسطينيين",
    en: "Boycott those who support killing Palestinians",
  },
  boycottTitle: {
    en: "Boycott!",
    ar: "قاطعوا",
  },
};

export default translation;
